import instance from '@apis/instance';
import { SliceResponse } from '@models/page';
import {
    FavoritePrepaidCardResponse,
    GetPrepaidCardTransactionsParams, GetPrepaidCardTransactionsResponse,
    PrepaidCardTransactionRow,
    UpdatePrepaidCardNameRequest,
    UserPrepaidCardResponse,
    UserPrepaidCardsResponse,
} from '@models/prepaidCard';

class UserPrepaidCardApi {
    static getUserPrepaidCards(): Promise<UserPrepaidCardsResponse> {
        return instance.get('/prepaid-cards');
    }

    static getUserPrepaidCard(userPrepaidCardId: string): Promise<UserPrepaidCardResponse> {
        return instance.get(`/prepaid-card/${userPrepaidCardId}`);
    }

    static getFavoritePrepaidCards(): Promise<FavoritePrepaidCardResponse> {
        return instance.get('/prepaid-cards/favorites');
    }

    static getPrepaidCardTransactions(id:string, params: GetPrepaidCardTransactionsParams): Promise<GetPrepaidCardTransactionsResponse> {
        return instance.get(`/prepaid-card/${id}/transactions`, { params });
    }

    static toggleFavorite(id: string):Promise<never> {
        return instance.patch(`/prepaid-card/${id}/favorites`);
    }

    static updatePrepaidCardName(id: string, request: UpdatePrepaidCardNameRequest): Promise<never> {
        return instance.patch(`/prepaid-card/${id}/name`, request);
    }

    static deletePrepaidCard(id: string): Promise<never> {
        return instance.delete(`/prepaid-card/${id}`);
    }

    static deleteAllPrepaidCards(): Promise<never> {
        return instance.delete('/prepaid-cards');
    }
}

export default UserPrepaidCardApi;
